import type { SVGProps } from 'react';

export function RedditGlyph({ width = 18, height = 18, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      aria-hidden="true"
      {...props}
    >
      {/* eslint-disable hotpads/no-magic-numbers -- Reddit brand color and glyph geometry */}
      <circle cx="12" cy="12" r="11" fill="#ff4500" />
      <path
        d="M7.25 13.1c0-2.22 2.12-4.02 4.75-4.02s4.75 1.8 4.75 4.02-2.12 4.02-4.75 4.02-4.75-1.8-4.75-4.02Z"
        fill="white"
      />
      <circle cx="9.85" cy="12.72" r="0.85" fill="#ff4500" />
      <circle cx="14.15" cy="12.72" r="0.85" fill="#ff4500" />
      <path
        d="M9.7 15.04c1.45.92 3.15.92 4.6 0"
        fill="none"
        stroke="#ff4500"
        strokeWidth="0.85"
        strokeLinecap="round"
      />
      <path
        d="m12.7 9.18.72-3.04 2.18.45"
        fill="none"
        stroke="white"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16.43" cy="6.78" r="1.05" fill="white" />
      {/* eslint-enable hotpads/no-magic-numbers */}
    </svg>
  );
}
